import { loadAsyncComponents } from '@akryum/vue-cli-plugin-ssr/client';
import './styles/scss/main.scss';
import './styles/main.pcss';
import { createApp } from './main';
import { fetchPosts } from './api';
import { generateRoutes } from './heplers';
import Layout from './components/Layout';
import VueGtm from 'vue-gtm';
import Vue from 'vue';
import { detect } from 'detect-browser';

const isOldSafari = (function () {
  const browser = detect();
  return browser.name === 'safari' && parseFloat(browser.version) < 11.3;
})();

createApp({
  async beforeApp({ router }) {
    await fetchPosts('getTree')
      .then((response) => {
        const _routes = response && response.data ? generateRoutes(response.data, Layout) : [];
        router.addRoutes(_routes);
      })
      .catch((error) => error);

    await loadAsyncComponents({ router });

    try {
      Vue.use(VueGtm, {
        id: 'GTM-PDKBNPV',
        enabled: false,
        debug: false,
        loadScript: !process.env.NODE_ENV,
        vueRouter: router,
      });
    } catch (e) {}
  },
  afterApp({ app, store }) {
    // Обработка момента если мы идем по ссылке с hash, иначе она удаляется
    if (window.location.hash && window.__INITIAL_STATE__['route']) {
      window.__INITIAL_STATE__['route'].fullPath += window.location.hash;
    }
    try {
      localStorage.setItem('isOldSafari', isOldSafari);

      //Если пак языков, сохраненный в localStorage не совпадает с паком языком из store.state, обнуляем localStorage
      let currentLanguagePack = store.state.selectedLanguagesPack;
      let storedLanguagePack = JSON.parse(localStorage.getItem('selectedLangs'));
      if (
        storedLanguagePack &&
        Object.keys(currentLanguagePack).length !== Object.keys(storedLanguagePack).length
      ) {
        localStorage.removeItem('selectedLangs');
      }
    } catch (e) {}
    store.replaceState(window.__INITIAL_STATE__);
    app.$mount('#app');
  },
}).catch();
